<template>
  <div class="box">
    <user-tile v-for="user in docs" :key="user._id" :user="user"></user-tile>
  </div>
</template>
<script>
import UserTile from "./user-tile";
export default {
  components: { UserTile },
  computed: {
    docs() {
      let component = this;
      return component.$store.getters["user/docs"];
    }
  },
  mounted() {
    let component = this;
    component.$store.dispatch("user/index");
  }
};
</script>